export default {
    computed: {
        isDisabled() {
            if (this.fields && this.fields.$form) {
                // console.log(':', this.fields.$form);
                // console.log(':', this.errors.any());
                // console.log(':', Object.keys(this.fields.$form).some(key => this.fields.$form[key].dirty || this.fields.$form[key].changed) );
                // console.log(':', Object.keys(this.fields.$form).every(key => this.fields.$form[key].validated) );
                // console.log(':', Object.keys(this.fields.$form).every(key => this.fields.$form[key].valid || this.fields.$form[key].valid == null) );
                return (
                    this.errors.any() ||
                    !(
                        Object.keys(this.fields.$form).some(key => this.fields.$form[key].dirty || this.fields.$form[key].changed) &&
                        (Object.keys(this.fields.$form).every(key => this.fields.$form[key].validated) ||
                            Object.keys(this.fields.$form).every(key => this.fields.$form[key].valid || this.fields.$form[key].valid == null))
                    )
                );
            }
            return true;
        }
    },
    methods: {
        fnHasErrors() {
            return !!this.errors.any();
        },
        fnHasError: function (item, scope = 'form') {
            const fields = scope ? this.fields['$' + scope] : this.fields;
            const name = scope ? scope + '.' + item : item;
            return (fields && fields[item] && fields[item].dirty && fields[item].invalid) || this.errors.has(name);
        },
        fnFirstError: function (item, scope = 'form') {
            const name = scope ? scope + '.' + item : item;
            return this.errors.has(name) ? this.errors.first(name) : null;
        },
        fnIsFieldChanged(name, scope = 'form') {
            const fields = scope ? this.fields['$' + scope] : this.fields;
            return fields && fields[name] ? fields[name].changed : false;
        },
        fnIsFormDirty(scope = 'form') {
            const fields = scope ? this.fields['$' + scope] : this.fields;
            if (!fields) {
                return false;
            }
            return Object.keys(fields).some(key => fields[key].dirty);
        },
        setFieldDirty(name, scope = 'form') {
            const matchOptions = {
                name: name,
                scope: scope
            };
            const field = this.$validator.fields.find(matchOptions);
            if (field) {
                field.setFlags({ dirty: true });
            }
        },
        async resetFieldValidator(name, scope = 'form') {
            return new Promise((resolve, reject) => {
                // Disables validation.
                this.$validator.pause();
                this.$nextTick(() => {
                    const matchOptions = {
                        // id: any, // if you have the id, otherwise its optional
                        name: name, // optional
                        scope: scope
                    };
                    const field = this.$validator.fields.find(matchOptions);
                    if (field) {
                        field.reset();
                        this.$validator.errors.remove(field.name, field.scope);
                        this.$validator.reset(field);
                    }
                    this.$validator.resume();
                    resolve(true);
                });
            });
        },
        async resetValidator() {
            // Disables validation.
            // this.$validator.pause();
            // return await this.$nextTick(() => {
            //     this.$validator.errors.clear()
            //     this.$validator.fields.items.forEach(field => field.reset())
            //     this.$validator.fields.items.forEach(field => this.errors.remove(field))
            //     // Resets field flags for all scoped fields. Resets all fields if no scope is provided.
            //     this.$validator.reset();
            //     // Enables validation.
            //     return this.$validator.resume();
            //     return true;
            // })

            return new Promise((resolve, reject) => {
                // Disables validation.
                this.$validator.pause();
                this.$nextTick(() => {
                    this.$validator.errors.clear();
                    this.$validator.fields.items.forEach(field => field.reset());
                    this.$validator.fields.items.forEach(field => this.errors.remove(field));
                    // Resets field flags for all scoped fields. Resets all fields if no scope is provided.
                    this.$validator.reset().then(res => {
                        // Enables validation.
                        this.$validator.resume();
                        resolve(true);
                    });
                });
            });
        },
        async validateAll(scope = 'form') {
            return await this.$validator
                .validateAll(scope)
                .then(result => {
                    if (!result) {
                        this.showError('global.msg.error.form');
                        return false;
                    }
                    return true;
                })
                .catch(error => {
                    return false;
                });
        },
        async validateField(name, scope = 'form') {
            return await this.$validator.validate(`${scope}.${name}`);
        },
    }
};